import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getReviews = ({ floor_id }) => ({ type: "GET_REVIEWS", floor_id })
export const getReviewsRequest = () => ({ type: "GET_REVIEWS_REQUEST" })
export const getReviewsSuccess = payload => ({ type: "GET_REVIEWS_SUCCESS", payload })
export const getReviewsFailed = error => ({ type: "GET_REVIEWS_FAILED", error })

export function* getReviewsSaga({ floor_id }) {
    yield put(getReviewsRequest())
    try {
        let { data: payload } = yield call(axios,`/floors/${floor_id}/reviews`)
        yield put(getReviewsSuccess(payload))
    } catch(err){
        yield put(getReviewsFailed(err))
    }
}

export default function* reviewsSagaWatcher() {
    yield takeEvery("GET_REVIEWS", getReviewsSaga)
}